import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createSlots as _createSlots, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "base-title-button"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "add_circle", -1)
const _hoisted_3 = { class: "base-title-button" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "settings", -1)
const _hoisted_5 = { class: "base-title-button" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "add_circle", -1)
const _hoisted_7 = {
  type: "submit",
  class: "btn btn-primary mt-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_BaseTitle = _resolveComponent("BaseTitle")!
  const _component_AlertError2 = _resolveComponent("AlertError2")!
  const _component_MenusOverview = _resolveComponent("MenusOverview")!
  const _component_base_container = _resolveComponent("base-container")!
  const _component_InputSelect = _resolveComponent("InputSelect")!
  const _component_input_checkbox_boolean = _resolveComponent("input-checkbox-boolean")!
  const _component_dp_form = _resolveComponent("dp-form")!
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_base_container, { "container-fluid": "" }, {
      default: _withCtx(() => [
        _createVNode(_component_BaseTitle, {
          title: _ctx.$t('menu'),
          "help-text": _ctx.$t('descriptionMenuSlotsDetail'),
          mb: 4,
          "back-route": _ctx.goBackRoute,
          "show-refresh-button": "",
          onRefresh: _ctx.reloadContent
        }, _createSlots({ _: 2 }, [
          (_ctx.fullMenuUI.isReady())
            ? {
                name: "buttons",
                fn: _withCtx(() => [
                  (_ctx.AbilityContext.isAuthorizedForFeature('MGMT_WEBSITE_MENU') && _ctx.AuthContext.isDpUser())
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createVNode(_component_router_link, {
                          to: {name: 'new-menu'},
                          class: "btn btn-hover icon-link text-green"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_2,
                            _createTextVNode(_toDisplayString(_ctx.$t('addMenu')), 1)
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("button", {
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openMenuSettings && _ctx.openMenuSettings(...args))),
                      class: "btn btn-hover icon-link"
                    }, [
                      _hoisted_4,
                      _createTextVNode(_toDisplayString(_ctx.$t('settings')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_router_link, {
                      to: {name: 'new-menu-item', params: {menu_id:_ctx.fullMenu.id}},
                      class: "btn btn-hover icon-link"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_6,
                        _createTextVNode(_toDisplayString(_ctx.$t('add')), 1)
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ])
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["title", "help-text", "back-route", "onRefresh"]),
        _createVNode(_component_AlertError2, {
          error: _ctx.fullMenuUI.getError(),
          class: "mb-3"
        }, null, 8, ["error"]),
        (_ctx.fullMenuUI.isReady())
          ? (_openBlock(), _createBlock(_component_MenusOverview, {
              key: 0,
              "menu-id": _ctx.fullMenu.id,
              "menu-items": _ctx.fullMenu.menu_items,
              "menu-ui": _ctx.fullMenuUI,
              bus: _ctx.bus
            }, null, 8, ["menu-id", "menu-items", "menu-ui", "bus"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_base_modal, {
      "modal-id": _ctx.modalMenuSettingsId,
      title: _ctx.$t('settings'),
      "no-footer": ""
    }, {
      default: _withCtx(() => [
        (_ctx.fullMenuUI.isReady())
          ? (_openBlock(), _createBlock(_component_dp_form, {
              key: 0,
              as: "form",
              onSubmit: _ctx.submitMenuSettings,
              novalidate: ""
            }, {
              default: _withCtx(({ errors }) => [
                _createVNode(_component_InputSelect, {
                  modelValue: _ctx.fullMenu.menu.layout_code,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.fullMenu.menu.layout_code) = $event)),
                  options: _ctx.menuLayoutOptions,
                  name: "menuLayoutOptions",
                  label: _ctx.$t('layout'),
                  selectText: _ctx.$t('selectText'),
                  rules: "required",
                  errors: errors
                }, null, 8, ["modelValue", "options", "label", "selectText", "errors"]),
                _createVNode(_component_InputSelect, {
                  modelValue: _ctx.fullMenu.menu.horizontal_position_code,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.fullMenu.menu.horizontal_position_code) = $event)),
                  options: _ctx.menuHorizontalPositionOptions,
                  name: "menuHorizontalPositionOptions",
                  label: _ctx.$t('horizontalPosition'),
                  selectText: _ctx.$t('selectText'),
                  rules: "required",
                  errors: errors
                }, null, 8, ["modelValue", "options", "label", "selectText", "errors"]),
                (_ctx.AuthContext.isDpUser() && _ctx.fullMenu.menu.code)
                  ? (_openBlock(), _createBlock(_component_input_checkbox_boolean, {
                      key: 0,
                      modelValue: _ctx.fullMenu.menu.is_submenu_allowed,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.fullMenu.menu.is_submenu_allowed) = $event)),
                      label: _ctx.$t('isSubmenuAllowed'),
                      name: "isSubmenuAllowed",
                      errors: errors
                    }, null, 8, ["modelValue", "label", "errors"]))
                  : _createCommentVNode("", true),
                _createElementVNode("button", _hoisted_7, _toDisplayString(_ctx.$t('save')), 1)
              ]),
              _: 1
            }, 8, ["onSubmit"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modal-id", "title"])
  ], 64))
}